import readingTime from 'reading-time';
import { stripHtml } from './cleanup';

export function computeReadTime(html: string) {
  const text = stripHtml(html);
  return Math.round(readingTime(text).minutes);
}
